import { Link } from "react-router-dom";

// material-ui
import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// project import
//import { APP_DEFAULT_PATH } from 'config';

// assets
import error401 from "assets/images/maintenance/Error401.png";

// ==============================|| ERROR 500 - MAIN ||============================== //

export default function Error401() {
  const downSM = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100vh" }}
    >
      <Grid item xs={12}>
        <Box sx={{ width: { xs: 350, sm: 396 } }}>
          <img
            src={error401}
            alt="mantis"
            style={{ height: "100%", width: "100%" }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Stack justifyContent="center" alignItems="center">
          <Typography align="center" variant={downSM ? "h2" : "h1"}>
            Access Denied
          </Typography>
          <Typography
            color="text.secondary"
            variant="body1"
            align="center"
            sx={{ width: { xs: "73%", sm: "70%", md: "100%" }, mt: 1 }}
          >
            You are not Authorize to View this Page
          </Typography>
          {/* <Button
            component={Link}
            to={"/"}
            variant="contained"
            sx={{ textTransform: "none", mt: 4 }}
          >
            Back To Home
          </Button> */}
        </Stack>
      </Grid>
    </Grid>
  );
}
